


import { Component, computed, effect, inject, signal } from '@angular/core';
import { TooltipDirective } from 'src/app/shared/directives/tooltip/tooltip.directive';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { OverflowPaddingDirective } from 'src/app/shared/directives/overflow-padding.directive';
import { TuiScrollbar } from '@taiga-ui/core';
import { TuiCheckbox, TuiSwitch } from '@taiga-ui/kit';
import { TuiInputModule } from '@taiga-ui/legacy';
import { CommonModule } from '@angular/common';
import { IntersectToolDirective } from './intersect.directive';

@Component({
  selector: 'intersect-button',
  standalone: true,
  imports: [TooltipDirective, MatMenuModule, FormsModule, OverflowPaddingDirective,     TuiCheckbox,CommonModule,
      TuiScrollbar,
      TuiSwitch,
      TuiInputModule,],
  template: `
  <button  appTooltip="Intersect with Property Boundary" [ngClass]="{'esk-tool--active' : isActive()===true}" (click)="tool.toggle()" class="esk-tool"><i class="fa fa-object-group"></i></button>
  `,
})
export class IntersectButtonComponent {
  readonly tool = inject(IntersectToolDirective);
  isActive = computed(() => this.tool.active());

  constructor()
  {
    effect(() => {
      console.log("Intersect is active:", this.isActive())
    })
  }
}
